// デザインシステムの統一されたテーマ - コバルトブルー・紫基調

export const theme = {
  colors: {
    primary: {
      gradient: 'linear-gradient(135deg, #0066ff 0%, #6a0dad 50%, #4169e1 100%)',
      cobalt: '#0066ff',
      violet: '#6a0dad', 
      royalBlue: '#4169e1',
      lightBlue: '#87ceeb',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
      tertiary: '#808080',
      accent: '#87ceeb',
    },
    background: {
      main: 'linear-gradient(135deg, #000000 0%, #0a0a0a 30%, #111111 100%)',
      secondary: 'rgba(255,255,255,0.05)',
      card: 'rgba(255,255,255,0.1)',
      cardHover: 'rgba(255,255,255,0.15)',
      input: 'rgba(255,255,255,0.05)',
      overlay: 'radial-gradient(circle at 20% 20%, rgba(0, 102, 255, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(106, 13, 173, 0.15) 0%, transparent 50%)',
    },
    border: {
      default: 'rgba(255, 255, 255, 0.1)',
      hover: 'rgba(0, 102, 255, 0.6)',
      accent: 'rgba(106, 13, 173, 0.6)',
      glow: 'rgba(106, 13, 173, 0.5)',
    }
  },
  fonts: {
    sizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '2rem',
      '4xl': '2.5rem',
    },
    weights: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeights: {
      tight: 1.4,
      normal: 1.6,
      relaxed: 1.8,
    }
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '2rem',
    '4xl': '2.5rem',
    '5xl': '3rem',
  },
  borderRadius: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1200px',
  },
  shadows: {
    card: '0 15px 30px rgba(0, 0, 0, 0.5)',
    cardHover: '0 20px 40px rgba(255, 0, 110, 0.2)',
    glow: '0 0 20px rgba(131, 56, 236, 0.5)',
    neonGlow: '0 0 30px rgba(6, 255, 165, 0.3)',
    intense: '0 0 50px rgba(255, 0, 110, 0.4)',
  }
} as const;

// テーマの型定義
export type Theme = typeof theme;
export type ThemeColors = typeof theme.colors;
export type ThemeFonts = typeof theme.fonts;
export type ThemeSpacing = typeof theme.spacing;
export type ThemeBorderRadius = typeof theme.borderRadius;
export type ThemeBreakpoints = typeof theme.breakpoints;
export type ThemeShadows = typeof theme.shadows;

// Styled-components向けのテーマ型定義
declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}